import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { app } from "../firebase"; 

export const redirectToCheckout = async ({ companyId }) => {
  const functions = getFunctions(app, 'us-central1'); 
  const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");

  const auth = getAuth();
  const user = auth.currentUser;

  const { data } = await createCheckoutSession({
    uid: user.uid,
    email: user.email,
    companyId,
  });

  if (data?.url) {
    window.location.href = data.url;
  } else {
    console.error("No URL returned from createCheckoutSession");
  }
}; 
